import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { ReactNode } from 'react';

interface Props {
    title: string;
    children: ReactNode;
    /** 비어 있을 때 보여줄 문구 */
    emptyText?: string;
    isEmpty?: boolean;
    closeLabel: string;
    onClose: () => void;
    /** 없으면 닫기 버튼 하나만 보여준다 */
    applyLabel?: string;
    onApply?: () => void;
    applyDisabled?: boolean;
}

/** 결제 화면에서 여는 바텀시트의 공통 틀 (제목 / 스크롤 내용 / 닫기·적용 버튼) */
function OrderSheetLayout({
    title, children, emptyText, isEmpty, closeLabel, onClose, applyLabel, onApply, applyDisabled,
}: Props) {
    return (
        <>
            <Header>
                <Text size='title' fontWeight='bold' color={colors.textPrimary}>{title}</Text>
            </Header>
            <Contents fullWidth spacing={2}>
                {children}
                {isEmpty && (
                    <Text align='center' color={colors.textThird}>{emptyText}</Text>
                )}
            </Contents>
            <Footer spacing={2} fullWidth>
                <Action variant={onApply ? 'tone' : 'filled'} onClick={onClose}>{closeLabel}</Action>
                {onApply && (
                    <Action disabled={applyDisabled} onClick={onApply}>{applyLabel}</Action>
                )}
            </Footer>
        </>
    );
}

const Header = styled.div`
    align-items: center;
    display: flex;
    height: 64px;
    justify-content: center;
`;

const Contents = styled(Column)`
    max-height: 60vh;
    overflow-y: auto;
    padding: 0 var(--spacing-4) var(--spacing-4);
`;

const Footer = styled(Row)`
    border-top: 1px solid var(--color-border-default);
    padding: var(--spacing-4) var(--spacing-4) calc(var(--spacing-4) + var(--safe-area-bottom));
`;

const Action = styled(Button)`
    flex: 1;
    padding: 0;
`;

export default OrderSheetLayout;
